import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextGamesSharedModule } from '@games/games-shared/text-games-shared.module';
import { SharedModule } from '@games/speed-reading/shared/shared.module';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TextsFilterComponent } from '@shared/components/games';
import { FontParametersModule } from '@shared/components/games/font-parameters';
import { SpeedreadingHeaderComponent } from '../shared/speedreading-header/speedreading-header.component';
import { SpeedtestReadingControllerComponent } from './speedtest-reading-controller/speedtest-reading-controller.component';
import { SpeedtestReadingCorrectAnswerPreviewComponent } from './speedtest-reading-preview/speedtest-reading-answer-preview/speedtest-reading-answer-preview.component';
import { SpeedtestReadingExamplePreviewComponent } from './speedtest-reading-preview/speedtest-reading-example-preview/speedtest-reading-example-preview.component';
import { SpeedtestReadingParametersPreviewComponent } from './speedtest-reading-preview/speedtest-reading-parameters-preview/speedtest-reading-parameters-preview.component';
import { SpeedtestReadingUserAnswerPreviewComponent } from './speedtest-reading-preview/speedtest-reading-user-answer-preview/speedtest-reading-user-answer-preview.component';
import { SpeedtestReadingSettingsComponent } from './speedtest-reading-settings/speedtest-reading-settings.component';

@NgModule({
  declarations: [
    SpeedtestReadingControllerComponent,
    SpeedtestReadingSettingsComponent,
    SpeedtestReadingCorrectAnswerPreviewComponent,
    SpeedtestReadingExamplePreviewComponent,
    SpeedtestReadingParametersPreviewComponent,
    SpeedtestReadingUserAnswerPreviewComponent,
  ],
  exports: [
    SpeedtestReadingControllerComponent,
    SpeedtestReadingSettingsComponent,
    SpeedtestReadingCorrectAnswerPreviewComponent,
    SpeedtestReadingExamplePreviewComponent,
    SpeedtestReadingParametersPreviewComponent,
    SpeedtestReadingUserAnswerPreviewComponent,
    NgSelectModule,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    TextsFilterComponent,
    SharedModule,
    TextGamesSharedModule,
    FontParametersModule,
    SpeedreadingHeaderComponent,

    GameButtonComponent,
    FormFieldModule,
  ],
})
export class SpeedtestReadingModule {}
